// src/components/CTASection.jsx
import React from "react";

export default function CTASection({ onCtaClick }) {
    return (
        <section
            className="py-24"
            style={{
                backgroundColor: "var(--bg-base)",
                color: "var(--text-primary)",
            }}
        >
            <div className="max-w-5xl mx-auto text-center px-6">

                {/* Headline */}
                <h2 className="text-4xl md:text-5xl font-semibold mb-4 text-[var(--text-primary)]">
                    Still Not Sure What to <span style={{ color: "var(--color-primary)" }}>Fix First?</span>
                </h2>



                {/* Subheader */}
                <p
                    className="text-lg md:text-lg lg:w-[50ch] mx-auto leading-relaxed mt-2"
                    style={{ color: "var(--text-secondary)" }}
                >
                    That's exactly what the first conversation is for.
                </p>

                {/* CTA button */}
                <div className="mt-10">
                    <button
                        onClick={onCtaClick}
                        className="inline-block px-8 py-3 rounded-md text-lg font-semibold transition-transform hover:no-underline hover:-translate-y-0.5"
                        style={{
                            backgroundColor: "var(--color-primary)",
                            color: "var(--bg-surface)",
                        }}
                    >
                        Start a Conversation
                    </button>
                </div>
            </div>
        </section>
    );
}
